/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getCards, getMarkers, updateMarker } from "../../../../../redux/action/card"
import { Button, Dropdown, DropdownButton } from "react-bootstrap"
import '../editors/walkthrough.css'
import '../editors/compiler.css'
import React from 'react'
import { getProducts } from "../../../../../redux/action/api"
import PrintManyModal from "../../../apps/payment-management/PrintManyModal"
import Card from "../card/Card"
import { FlexCol, FlexRow } from "../../../../../_4threal/helpers/CssHelpers"
import { downloadFile } from "../helpers/Helpers"
// import { disableNetwork } from "firebase/firestore"

const getVariantFromMarker: any = (marker, products) => {
  // console.log('products!!!!!!!!!', products)
  // console.log('marker!!!!!!!!!', marker)
  return Object.values(products[marker?.type].variants).find(
    (variant: any) => variant.variant_id === marker?.cart.variantId
  )
}

function AddToCartModal(props: any) {
  const { scenes, setIsSceneModalOpen } = props
  return (
    <>
      <div className='modal fade show d-block' style={{ display: 'flex', padding: '40px' }} aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <p className='fw-b'>Pick An Experience To Buy Products For</p>
            </div>
            <div className='modal-body scroll-y mx-xl-10'>
              {Object.keys(scenes).map((sceneId: any, i) => (
                <div key={i}>
                  {scenes[sceneId]?.protected?.isActive &&
                    <div className={"w-100 my-5 card-shadowbox gap-1" + FlexCol}>
                      <img className='w-100' src={scenes[sceneId].previewUrl} alt=''/>
                      <div>Project Name: {scenes[sceneId]?.name?.length > 0 ? scenes[sceneId].name : '[Untilted Project]'}</div>
                      <Button className='mb-3' variant="primary" onClick={() => window.location.href = `/pmenu/repeat/${sceneId}`}>Order Products</Button>
                    </div>
                  }
                </div>
              ))}
              <Button className='mt-7' variant="secondary" onClick={() => setIsSceneModalOpen(false)}>Close</Button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

function RemoveFromCartModal(props: any) {
  const { confirmMarkerRemoval, denyMarkerRemoval } = props
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1001 }}>
      <div className='p-5' style={{ width: '250px', backgroundColor: '#fff', borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)' }}>
        <p className='fs-3'>Remove from cart?</p>
        <div className={"w-100 gap-3" + FlexRow}>
          <Button className='mt-7' variant="secondary" onClick={denyMarkerRemoval}>Close</Button>
          <Button className='mt-7' variant="danger" onClick={confirmMarkerRemoval}>Remove</Button>
        </div>
      </div>
    </div>
  )
}

function ShoppingCartMarker(props: any) {
  let { products, marker, svgRef, updateMarkerCountInCart, openRemoveMarkerModal } = props

  const dispatch = useDispatch()

  const handleDownload  = (fileType) => downloadFile(fileType, svgRef.current[marker._id], marker, dispatch)

  const [variant, setVariant]: any = useState({ minimum: 1, price: 0, count: 1 })
  const [productCount, setProductCount] = useState<number>(marker?.cart?.quantity || 0)

  useEffect(() => {
    if(marker && products) {
      setVariant(getVariantFromMarker(marker, products))
    }
  }, [marker, products])

  useEffect(() => {
    if(marker && products) {
      setVariant(getVariantFromMarker(marker, products))
    }
  }, [])

  const handleQuantityChange = async (val) => {
    if (productCount <= variant.minimum && val <= 0) {
      openRemoveMarkerModal(marker._id, marker.sceneId)
    } else {
      let newVal = productCount < variant.minimum && val > 0
        ? variant.minimum
        : productCount + val

      setProductCount(newVal)
      updateMarkerCountInCart(marker._id, marker.sceneId, newVal)
    }
  }

  return (
    <div className='px-5 py-2 col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4'>
      <div className="card-shadowbox">
        <div className={'w-100 my-3 gap-2' + FlexRow}>
          <div className="fs-5">{products[marker.type]?.name || 'Custom'}</div>
        </div>
        {products &&
          <div className="fs-1 m-auto w-100">${(variant?.price * marker?.cart?.quantity)?.toFixed(2)}</div>
        }
        <div className={'w-100 gap-2' + FlexRow}>
          <div className={'w-100 mt-2 gap-2' + FlexRow}>
            <Button className="btn-sm fs-1" style={{width: '60px'}} onClick={() => handleQuantityChange(-1)}>
              {productCount === variant?.minimum
                ? <svg className="m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0,0,256,256" width="22px" height="22px" fillRule="nonzero"><g fill="#ffffff" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10"><g transform="scale(10.66667,10.66667)"><path d="M10,2l-1,1h-4c-0.6,0 -1,0.4 -1,1c0,0.6 0.4,1 1,1h2h10h2c0.6,0 1,-0.4 1,-1c0,-0.6 -0.4,-1 -1,-1h-4l-1,-1zM5,7v13c0,1.1 0.9,2 2,2h10c1.1,0 2,-0.9 2,-2v-13zM9,9c0.6,0 1,0.4 1,1v9c0,0.6 -0.4,1 -1,1c-0.6,0 -1,-0.4 -1,-1v-9c0,-0.6 0.4,-1 1,-1zM15,9c0.6,0 1,0.4 1,1v9c0,0.6 -0.4,1 -1,1c-0.6,0 -1,-0.4 -1,-1v-9c0,-0.6 0.4,-1 1,-1z"></path></g></g></svg>
                : <div className="m-auto">-</div>
              }
            </Button>
            <div className="fs-2" style={{width: '50px'}}>{productCount * variant?.count}</div>
            <Button className="btn-sm fs-1" style={{width: '60px'}} onClick={() => handleQuantityChange(1)}>
              <div className="m-auto">+</div>
            </Button>
          </div>
        </div>
        <div className="m-6">
          <Card marker={marker} disableEditing={true} ref={e => svgRef.current[marker._id] = e} />
        </div>

        <DropdownButton className='mb-6' id="dropdown-basic-button" title="Digital Download">
          <Dropdown.Item as='button' onClick={() => handleDownload('svg')}>Download SVG</Dropdown.Item>
          <Dropdown.Item as='button' onClick={() => handleDownload('png')}>Download PNG</Dropdown.Item>
          <Dropdown.Item as='button' onClick={() => handleDownload('pdf')}>Download PDF</Dropdown.Item>
        </DropdownButton>
      </div>
    </div>
  )
}

function ShoppingCart(props: any) {
  const {
    parsedCart,
    scenes,
    products,
    updateMarkerCountInCart,
    svgRef,
    hasItems,
  } = props

  const [isSceneModalOpen, setIsSceneModalOpen] = useState(false)
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false)
  const [markerIdToRemove, setMarkerIdToRemove] = useState(['', ''])

  const openRemoveMarkerModal = (markerId, sceneId) => {
    setIsRemoveModalOpen(true)
    setMarkerIdToRemove([markerId, sceneId])
  }

  const confirmMarkerRemoval = () => {
    setIsRemoveModalOpen(false)
    updateMarkerCountInCart(markerIdToRemove[0], markerIdToRemove[1], 0)
  }

  const denyMarkerRemoval = () => {
    setIsRemoveModalOpen(false)
    setMarkerIdToRemove(['',''])
  }

  return (
    <>
      {isSceneModalOpen && <AddToCartModal scenes={scenes} setIsSceneModalOpen={setIsSceneModalOpen} />}
      {isRemoveModalOpen && <RemoveFromCartModal confirmMarkerRemoval={confirmMarkerRemoval} denyMarkerRemoval={denyMarkerRemoval} />}
      <div className={'w-100 mt-10' + FlexCol}>
        <div className={'walkthrough-shadowbox mx-3 mb-10 ' + (!hasItems ? 'mt-10' : '')}>
          <div className={'w-100 gap-4' + FlexCol}>
            <div className='row' style={{ margin: '15px', fontSize: '15px', textAlign: 'center', paddingLeft: '1vw', paddingRight: '1vw', }}>
              {!hasItems
              ? <div className={'w-100' + FlexCol}>
                  <p className='text-center'>Your shopping cart is empty</p>
                  <Button variant="primary" className='fs-2' style={{width: '10em'}} onClick={() => setIsSceneModalOpen(true)}>Buy Products</Button>
                </div>
              : <>
                  {Object.keys(parsedCart).map((sid: any, i) => (
                    <React.Fragment key={i}>
                      <div className='my-3'>Your Experience: {parsedCart[sid]?.name}</div>
                      <div className={'w-100 mb-3 gap-3' + FlexRow}>
                        <img className='card-shadowbox p-0' style={{maxWidth: '200px'}} src={parsedCart[sid]?.previewUrl} alt='' />
                      </div>
                      <div className={'w-100 gap-3' + FlexRow}>
                          <Button variant="primary" className='btn my-1' style={{maxWidth: '200px'}}
                            onClick={() => window.location.href = `/pmenu/repeat/${sid}`}>
                            Buy More Products
                          </Button>
                      </div>
                      <div className='row my-10 mx-auto'>
                        {Object.keys(parsedCart[sid]?.markers).map((markerId: any, j) => (
                          <ShoppingCartMarker key={j}
                            products={products}
                            marker={parsedCart[sid].markers[markerId]}
                            svgRef={svgRef}
                            updateMarkerCountInCart={updateMarkerCountInCart}
                            openRemoveMarkerModal={openRemoveMarkerModal} />
                        ))}
                      </div>
                    </React.Fragment>
                  ))}
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function ShoppingCartContainer() {

  const products = useSelector((state: any) => state.Api?.products || {})
  const svgRef = useRef({})
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  const [cartTotal, setCartTotal] = useState(0)
  const markers = useSelector((state: any) => state.Card?.UserMarkerObj || {})
  const scenes = useSelector((state: any) => state.Card?.UserCardObj || {})
  const [parsedCart, setParsedCart] = useState({})
  const [hasItems, setHasItems] = useState(false)
  const closeCheckoutModal = () => setIsPaymentModalOpen(false)
  const dispatch = useDispatch()

  const updateMarkerCountInCart = async (markerId, sceneId, quantity) => {
    let cart = {...parsedCart};
    let scene = {...cart[sceneId]};
    let marker = {...scene.markers[markerId]}
    let variant = getVariantFromMarker(marker, products)
    let lastentry = marker.cart
    let entry = {
      cart:{
        variantId: variant.variant_id,
        printful_variant_id: variant.printful_variant_id,
        quantity: quantity,
        price: variant.price,
        lastPrice: lastentry.price,
      }
    }
    marker['cart'] = entry.cart
    cart[sceneId].markers[markerId] = marker
    setParsedCart(cart)
    const res = dispatch(updateMarker(marker))
    if (!res) {
      marker['cart'] = lastentry
      cart[sceneId].markers[markerId] = marker
      setParsedCart(cart)
    }
  }

  useEffect(() => {
    dispatch(getMarkers())
    dispatch(getProducts())
    dispatch(getCards())
  }, [])

  useEffect(() => {
    if (Object.keys(markers).length === 0 || Object.keys(scenes).length === 0 || Object.keys(products).length === 0) {
      return;
    }
    let cart = {}

    Object.keys(markers).forEach(markerId => {
      //console.log('markerid', markerId)
      const marker = {...markers[markerId]}
      //console.log('marker', marker)
      if ('cart' in marker && marker.cart?.quantity > 0 && marker.sceneId) {
        if (marker.sceneId in scenes) {
          if (marker.sceneId in cart) {
            cart[marker.sceneId]['markers'][markerId] = marker;
          }else{
            let scene = {...scenes[marker.sceneId]}
            scene['markers'] = {}
            scene['markers'][markerId] = marker
            cart[marker.sceneId] = scene;
          }
        }
      }
    })

    setParsedCart(cart)

  }, [markers, scenes, products])

  useEffect(() => {
    setHasItems(false)
    let total = 0;
    Object.keys(parsedCart).forEach(sceneId => {
      let scene = parsedCart[sceneId]
      Object.keys(scene.markers).forEach(markerId => {
       setHasItems(true)
        let marker = scene.markers[markerId]
        let variant = getVariantFromMarker(marker, products)
        let price = variant.price
        total += marker.cart.quantity * price
      })
    })
    setCartTotal(total)
  }, [parsedCart])

  return (
    <>
      {isPaymentModalOpen &&
        <>
          <div className='modal fade show d-block' style={{ display: 'flex', padding: '40px' }} aria-modal='true'>
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h2 className='fw-bolder'>Checkout</h2>
                </div>
                <div className='modal-body scroll-y mx-xl-10'>
                  <PrintManyModal parsedCart={parsedCart} svgRef={svgRef} closeModal={closeCheckoutModal} />
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      }
      <div className='post-walkthrough-steps'>
        <div className='row'>
          <div className='col-12'>
            {hasItems &&
              <>
                <div className={'mt-5 w-100 fs-1' + FlexRow}>
                  Subtotal: ${(cartTotal).toFixed(2)}
                </div>
                <div className={'mt-5 w-100 gap-3' + FlexRow}>
                  <Button variant="primary" onClick={() => setIsPaymentModalOpen(true)}>Continue To Checkout</Button>
                  {/* <Button variant="secondary" onClick={clearShoppingCart}>Empty Cart</Button> */}
                </div>
              </>
            }
            <ShoppingCart
              parsedCart={parsedCart}
              scenes={scenes}
              products={products}
              hasItems={hasItems}
              updateMarkerCountInCart={updateMarkerCountInCart}
              svgRef={svgRef}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ShoppingCartContainer